module.exports = __webpack_public_path__ + "./img/no-photo.8b3fddaa51e067f8af59adafcc855033.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Shared/images/no-photo.jpg
// module id = ./src/components/Shared/images/no-photo.jpg
// module chunks = 0